import React, { useEffect, useState } from "react";
import { Table, Button, Form, InputGroup, Pagination, ToastContainer } from "react-bootstrap";
import { PencilSquare, Trash, Check, X, Check2Circle, XCircle } from "react-bootstrap-icons";
import NewTopNavBar from "../NewTopNavBar";
import { toast } from "react-toastify";
import axios from "axios";
import { API_BASE_URL } from "../../environment";
import { useNavigate } from "react-router-dom";
import addImg from "../../Img/create.png";
import swichImg from "../../Img/settings.png"
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { parseISO } from 'date-fns';
import { format } from 'date-fns';
const TenantConfigarationCred = () => {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState('');
  const [newRow, setNewRow] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  let bearerToken = localStorage.getItem("jwt_token");
  const config = {
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      "Content-Type": "application/json",
    },
  };
  const navigate=useNavigate('/tenant-config')
  // Fetch all data on component mount
  useEffect(() => {
    fetchData();
  }, [data.length ]);

  const fetchData = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/wp-json/custom/v1/tenant-confiration`,config);
      setData(res.data);
    } catch (error) {
      toast.error('Failed to fetch data');
    }
  };

  const handleAddRow = () => {
    setNewRow({
      whitelist_url: '',
      tenant_url: '',
      subscription_start_date: '',
      subscription_end_date: '',
    });
  };

  const handleSaveNew = async () => {
    if(!newRow.whitelist_url || !newRow.tenant_url || !newRow.subscription_start_date || !newRow.subscription_end_date){
      toast.error('All fields are required');
      return;
    }
    if (!newRow.subscription_start_date) {
      toast.error('Subscription Start Date is required');
      return;
    }

    try {
      const res = await axios.post(`${API_BASE_URL}/wp-json/custom/v1/tenant-confiration`, newRow,config);
      setData([res.data, ...data]);
      setNewRow(null);
      toast.success('Details created successfully');
    } catch (error) {
      toast.error('Failed to create details - The provided Whitelist URL and Tenant URL already exist. Please enter different values.');
    }
  };

  const handleEdit = (id) => {
    
    setEditingId(id);
  };

  const handleSaveEdit = async (id) => {
    
    const editedRow = data.find((row) => row.id === id);
    if(!editedRow.whitelist_url || !editedRow.tenant_url || !editedRow.subscription_start_date || !editedRow.subscription_end_date){
      toast.error('All fields are required');
      return;
    }
    if (!editedRow.subscription_start_date) {
      toast.error('Subscription Start Date is required');
      return;
    }

    console.log("editrow87=",editedRow)

    try {
      await axios.put(`${API_BASE_URL}/wp-json/custom/v1/tenant-confiration`, editedRow,config);
      toast.success('Details updated successfully');
      setEditingId(null);
    } catch (error) {
      toast.error('Failed to create details - The provided Whitelist URL and Tenant URL already exist. Please enter different values.');
    }
  };

  const handleDelete = (id) => {
    toast.warn('This DELETE functionality needs to be added.'); // Placeholder
    // Add a DELETE API and handle it here.
  };

  const handleChange = (field, value, id = null) => {
   
    if (id !== null) {
      setData((prev) =>
        prev.map((row) =>
          row.id === id ? { ...row, [field]: value } : row
        )
      );
    } else {
      setNewRow({ ...newRow, [field]: value });
    }
  };

  const filteredData = data.filter((row) =>
    Object.values(row).some((value) =>
      value?.toString().toLowerCase().includes(search.toLowerCase())
    )
  );
  const filteredDataPagenation = data.filter((row) =>
    Object.values(row).some((value) =>
      value?.toString().toLowerCase().includes(search.toLowerCase())
    )
  );
  
  // Get paginated data
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredDataPagenation.slice(indexOfFirstItem, indexOfLastItem);
  
  const totalPages = Math.ceil(filteredDataPagenation.length / itemsPerPage);
  function formatDateToDDMMYYYY(dateStr) {
    const dateObj = new Date(dateStr);
    const day = String(dateObj.getDate()).padStart(2, '0');
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const year = dateObj.getFullYear();
    return `${month}-${day}-${year}`;
  }
  const parseISODateToMMDDYYYY = (isoDate) => {
    if (!isoDate) return "";
    const [year, month, day] = isoDate.split('-');
    return `${month}/${day}/${year}`;
  };
  return (
  <div className=""> 
    <NewTopNavBar/> 
    <div className="container mt-4 pt-5">
      <h4 className="text-center">Manage URL/Subscription</h4>
      <ToastContainer position="top-right" autoClose={3000} />
      {/* <div className="text-end">
      <Button onClick={handleAddRow}>Add</Button>
      </div> */}
      <div className="d-flex justify-content-between mb-3">
        
        <InputGroup style={{ width: '300px' }}>
          <Form.Control
            placeholder="Search..."
            onChange={(e) => setSearch(e.target.value)}
          />
        </InputGroup>
        {/* <div>
        <Button onClick={()=>navigate('/tenant-config')}>Tenant Config</Button>
        <Button onClick={handleAddRow}>Add</Button>
        </div> */}
                <div>
                  {/* <button className='btn btn-primary' onClick={handleShowCategory}>  {editWhistlist ? "Add/Edit" : "Add"} categories</button> */}
                  <img
                    className="mt-2 commonLogo"
                    onClick={()=>navigate('/tenant-config')}
                    width={25}
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="Tenant Configuration "
                    role="button"
                    src={swichImg}
                    alt="Tenant Configuration "
                  />
                  <img
                    className="mt-2 ms-3 commonLogo"
                    onClick={handleAddRow}
                    width={25}
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="Add"
                    role="button"
                    src={addImg}
                    alt="Add"
                  />
                </div>
        </div>

      <Table striped bordered hover responsive>
        <thead className="text-center">
          <tr>
            <th>Whitelist URL</th>
            <th>Tenant URL</th>
            <th>Subscription Start Date</th>
            <th>Subscription End Date</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody >
          {newRow && (
            <tr className="text-center">
              <td>
                <Form.Control
                  value={newRow.whitelist_url}
                  onChange={(e) =>
                    handleChange('whitelist_url', e.target.value)
                  }
                />
              </td>
              <td>
                <Form.Control
                  value={newRow.tenant_url}
                  onChange={(e) =>
                    handleChange('tenant_url', e.target.value)
                  }
                />
              </td>
              <td>
                
                {/* <Form.Control
                  type="date"
                  value={newRow.subscription_start_date}
                  onChange={(e) =>
                    handleChange('subscription_start_date', e.target.value)
                  }
                /> */}
                  {newRow && (
                    <DatePicker
                      selected={
                        newRow.subscription_start_date
                          ? parseISO(newRow.subscription_start_date)
                          : null
                      }
                      onChange={(date) =>
                        handleChange(
                          'subscription_start_date',
                          format(date, 'yyyy-MM-dd')
                         
                        )
                      }
                      dateFormat="MM/dd/yyyy"
                      className="form-control"
                      placeholderText="MM/DD/YYYY"
                    />
                  )}
              </td>
              <td>
                {/* <Form.Control
                  type="date"
                  value={newRow.subscription_end_date}
                  onChange={(e) =>
                    handleChange('subscription_end_date', e.target.value)
                  }
                /> */}
                      {newRow && (
                    <DatePicker
                      selected={
                        newRow.subscription_end_date
                          ? parseISO(newRow.subscription_end_date)
                          : null
                      }
                      onChange={(date) =>
                        handleChange(
                          'subscription_end_date',
                          format(date, 'yyyy-MM-dd')
                          // newRow.id
                        )
                      }
                      dateFormat="MM/dd/yyyy"
                      className="form-control"
                      placeholderText="MM/DD/YYYY"
                    />
                  )}
              </td>
              <td>
                <Check2Circle
                  color="green"
                  size={22}
                  style={{ cursor: 'pointer', marginRight: '10px' }}
                  onClick={handleSaveNew}
                />
                <XCircle
                  color="red"
                  size={22}
                  style={{ cursor: 'pointer' }}
                  onClick={() => setNewRow(null)}
                />
              </td>
            </tr>
          )}
          {currentData.map((row) => (
            <tr key={row.id} className="tenat-config-table">
              <td>
                {editingId === row.id ? (
                  <Form.Control
                    value={row.whitelist_url}
                    onChange={(e) =>
                      handleChange('whitelist_url', e.target.value, row.id)
                    }
                  />
                ) : (
                  row.whitelist_url
                )}
              </td>
              <td>
                {editingId === row.id ? (
                  <Form.Control
                    value={row.tenant_url}
                    onChange={(e) =>
                      handleChange('tenant_url', e.target.value, row.id)
                    }
                  />
                ) : (
                  row.tenant_url
                )}
              </td>
              <td>
                
                {editingId === row.id ? (
                  // <Form.Control
                  //   type="date"
                  //   value={row.subscription_start_date}
                  //   onChange={(e) =>
                  //     handleChange('subscription_start_date', e.target.value, row.id)
                  //   }
                  // />
                  
                  row && <DatePicker
                  selected={
                    row?.subscription_start_date
                      ? parseISO(row.subscription_start_date)
                      : null
                  }
                  onChange={(date) =>
                    handleChange(
                      'subscription_start_date',
                      format(date, 'yyyy-MM-dd'),
                      row?.id
                    )
                  }
                  dateFormat="MM/dd/yyyy"
                  className="form-control"
                  placeholderText="MM/DD/YYYY"
                  />
                ) : (
                  formatDateToDDMMYYYY(row.subscription_start_date)
                )}
              </td>
              <td>
                {/* {console.log("line335=",newRow.subscription_end_date)} */}
                {editingId === row.id ? (
                  // <Form.Control
                  //   type="date"
                  //   value={row.subscription_end_date}
                  //   onChange={(e) =>
                     
                  //     handleChange('subscription_end_date', e.target.value, row.id)
                  //   }
                  
                    
                  // />
                  row && <DatePicker
                  selected={row.subscription_end_date ? parseISO(row.subscription_end_date) : null}
                  onChange={(date) => handleChange('subscription_end_date', format(date, 'yyyy-MM-dd'),row.id)}
                  dateFormat="MM/dd/yyyy"
                  className="form-control"
                  placeholderText="MM/DD/YYYY"
                  />
                ) : (
                  formatDateToDDMMYYYY(row.subscription_end_date)
                )}
              </td>
              <td>
                {editingId === row.id ? (
                  <>
                  <Check2Circle
                    color="green"
                    size={22}
                    style={{ cursor: 'pointer', marginRight: '10px' }}
                    onClick={() => handleSaveEdit(row.id)}
                  />
                  <XCircle
                  color="red"
                  size={22}
                  style={{ cursor: 'pointer' }}
                  onClick={() => setEditingId(null)}
                />
                  </>
                ) : (
                  <PencilSquare
                    size={20}
                    style={{ cursor: 'pointer', marginRight: '10px' }}
                    onClick={() => handleEdit(row.id)}
                  />
                )}
                {/* <Trash
                  size={20}
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleDelete(row.id)}
                /> */}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <div>
    <ul className="pagination mb-0 d-flex justify-content-end">
      {[...Array(totalPages)].map((_, index) => (
        <li
          key={index}
          className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}
        >
          <Button
            className="page-link"
            onClick={() => setCurrentPage(index + 1)}
            size="sm"
            variant="primary"
          >
            {index + 1}
          </Button>
        </li>
      ))}
    </ul>
  </div>
    </div>
    </div>  
  );
};
export default TenantConfigarationCred;